import { CustomAttributeFieldConfig } from 'src/graphql/entities/custom-attributes/field-view-registry/types';
import {
  getKindLikeValueSafely,
  getNonEmptyString,
} from 'src/graphql/entities/custom-attributes/field-view-registry/utils';
import { DateEditor, DateTimeEditor } from './date-edit';
import { DateTimeView, DateView } from './date-view';

export const DATE_FIELD_CONFIG: CustomAttributeFieldConfig = {
  type: 'date',
  editable: true,
  directEdit: true,
  insetByControl: true,
  View: DateView,
  Editor: DateEditor,
  decode: (raw) => ({ kind: 'date', value: getNonEmptyString(raw) }),
  encode: (value) => getKindLikeValueSafely(value, 'date'),
  isEmpty: (value) => !getKindLikeValueSafely(value, 'date'),
};

export const DATE_TIME_FIELD_CONFIG: CustomAttributeFieldConfig = {
  type: 'date_time',
  editable: true,
  directEdit: true,
  insetByControl: true,
  View: DateTimeView,
  Editor: DateTimeEditor,
  decode: (raw) => ({ kind: 'date_time', value: getNonEmptyString(raw) }),
  encode: (value) => getKindLikeValueSafely(value, 'date_time'),
  isEmpty: (value) => !getKindLikeValueSafely(value, 'date_time'),
};
